<template>
    <div class="dialog-body">
        <h1>Change mobile or email</h1>

        <div class="info-container">
            <div class="form-sec">
                <form method="post" :action="url"
                    novalidate="novalidate">
                    <input type="hidden" name="_token" :value="$csrf">
                    <div class="form-group">
                        <label>MOBILE PHONE</label>
                        <input type="text" class="form-control col-md-4" id="mobile" placeholder="Enter phone number"
                            name="mobile" v-model="mobile" maxlength="12" />
                    </div>
                    <div class="form-group">
                        <label>EMAIL</label>
                        <input type="email" class="form-control col-md-10" id="email" placeholder="Enter email"
                            name="email" v-model="email" maxlength="191" />
                    </div>
                    <button type="submit" class="btn btn-blue">
                        UPDATE INFO
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        // Note: data-email and data-mobile becomes camel case in props
        props: ['dataEmail', 'dataMobile'],
        data() {
            return {
                url: this.$routes['member_update_contact'],
                email: this.dataEmail,
                mobile: this.dataMobile,
                isSubmitting: false,
                errorMessage: '',
            }
        },
        methods: {
            // async submitForm() {
            //     this.isSubmitting = true;
            //     this.errorMessage = '';
            //     var result = await this.$asyncPost(, {
            //         'email': this.email,
            //         'mobile': this.mobile
            //     });
            //     this.isSubmitting = false;

            //     if (result.status == 'success') {
            //         Swal.fire({
            //           type: 'success',
            //           title: 'Success',
            //           text: result.message,
            //         }).then(() => {
            //             this.$redirect(this.$routes['member_profile']);
            //         });
            //     } else {
            //         this.errorMessage = result.message;
            //     }

            // }
        },

        
    }
</script>
